/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  function appendSubscriptionText() {
    // Get all labels and find the one with "Subscribe and Save"
    const allLabels = document.querySelectorAll('label');
    
    allLabels.forEach(label => {
     
      if (label.textContent.trim() === 'Subscribe and Save' && 
          !label.textContent.includes('Auto-renews')) {
        label.textContent += ' ( Auto-renews, skip or cancel anytime )';
      }
    });
  }

  function hideOriginalPolicyText() {
    // Hide the original policy text since we moved it to the label
    const policyElement = document.querySelector('.shopify_subscriptions_app_policy');
    
    if (policyElement) {
      policyElement.style.display = 'none';
    }
  }

  // Run both functions with delays
  setTimeout(() => {
    appendSubscriptionText();
    hideOriginalPolicyText();
  }, 1000);
  
  setTimeout(() => {
    appendSubscriptionText();
    hideOriginalPolicyText();
  }, 2000);

 

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
